'use strict';

/**
 * @param {Object} dst
 * @param {Object} src
 * @returns {Object|Array}
 */
export function extend(dst, ...src) {
  for(let source of src) {
    merge(dst, copy(source));
  }
  return dst;
}
/**
 * @param {Object} dst
 * @param {Object} src
 * @returns {Object}
 */
export function merge(dst, src) {
  for(let key in src) {
    if (src.hasOwnProperty(key)) {
      dst[key] = src[key];
    }
  }
  return dst;
}
/**
 * WARNING: works only with {Boolean|Number|String|Array|Object|null|undefined} types
 * @see https://github.com/nervgh/yum.js/blob/master/src/yum.js#L143
 * @param any
 * @returns {*}
 */
export function copy(any) {
  // Number, String, Boolean, null, undefined
  if (isPrimitive(any)) {
    return any;
  }
  // We cannot copy FormData objects
  if (isFormData(any)) {
    return any
  }

  let root = Array.isArray(any) ? [] : {};
  for (let key in any) {
    if (any.hasOwnProperty(key)) {
      root[key] = copy(any[key]);
    }
  }
  return root;
}
/**
 * @param {*} any
 * @return {Boolean}
 */
function isFormData(any) {
  return Object.prototype.toString.call(any) === '[object FormData]'
}
/**
 * @param {*} any
 * @returns {Boolean}
 */
export function isPrimitive(any) {
  if (any === null) {
    return true;
  }
  switch (typeof any) {
    case 'boolean':
    case 'number':
    case 'string':
    case 'null':
    case 'undefined':
      return true;
    default:
      return false;
  }
}
/**
 * @param {*} any
 * @returns {Boolean}
 */
export function isString(any) {
  return typeof any === 'string';
}
/**
 * @param {*} any
 * @returns {Boolean}
 */
export function isUndefined(any) {
  return any === undefined;
}
/**
 * @param {String} url
 * @param {Object} options
 * @param {Function} fetchFn
 * @returns {Promise}
 */
export function request(url, options, fetchFn) {
  let {method,headers,body} = options;
  let contentTypeKey = 'Content-Type'
  let contentTypeValue = String(headers[contentTypeKey])
  let isJson = contentTypeValue.slice(0, 16) === 'application/json';
  let body_ = isJson ? JSON.stringify(body) : body;
  if (window.fetch === fetchFn) {
    return fetchFn(url, {
      method,
      headers,
      body: body_
    });
  }
  if (window.jQuery && window.jQuery.ajax === fetchFn) {
    let isMultipart = contentTypeValue.slice(0, 19) === 'multipart/form-data' ||
                      isFormData(body_)
    // We must remove contentType when the request is multipart/form-data
    // Otherwise we will have the "Multipart: Boundary not found" error
    if (isMultipart) {
      delete headers[contentTypeKey]
    }
    return fetchFn(url, {
      type: method,
      headers,
      processData: !isMultipart,
      // jQuery must not control contentType for "multipart/form-data" requests
      // Otherwise we will have the "Multipart: Boundary not found" error
      // https://stackoverflow.com/a/8244082
      contentType: isMultipart ? false : contentTypeValue,
      data: body_
    });
  }
  throw new Error('You must specify the "fetch" function!');
}
/**
 * @param {*} argument
 * @returns {*}
 */
export function identity(argument) {
  return argument;
}


// WEBPACK FOOTER //
// ./src/js/lang.js